(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9975],{

/***/ 20666:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CommonLandingPage": () => (/* binding */ CommonLandingPage),
/* harmony export */   "__N_SSP": () => (/* binding */ __N_SSP),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83636);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(576);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44928);
/* harmony import */ var _tm_static_pages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91381);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58524);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87109);
/* harmony import */ var _tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63837);
/* harmony import */ var _tm_ui_hoc__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99234);
/* harmony import */ var _tm_utility_analytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11508);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _src_utils_webVitals__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21810);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _src_hoc__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8367);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)(); // Conditional dynamic imports with SSR enabled - only load what's needed based on device
// Using webpack magic comments for better code splitting

const InsuranceLanding = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91381)).then(mod => mod.InsuranceLanding), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(91381)]
  }
});
const InsuranceCommonLanding = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91381)).then(mod => mod.InsuranceCommonLanding), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(91381)]
  }
}); // Lazy load header HOC modules for code splitting
// Create wrapper components that use the HOCs internally
// This enables proper code splitting while maintaining SSR

const GIHeaderWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99234)).then(mod => {
  const {
    withGIInsuranceHeader
  } = mod;
  return function GIHeaderWrapperComponent({
    children,
    headerOptions,
    mobileTitle,
    myOrders,
    goToMyOrders,
    displayWhiteHeader,
    showPwaHeaderBackButton,
    onLoginSuccess
  }) {
    return withGIInsuranceHeader( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
      children: children
    }), headerOptions, mobileTitle, myOrders, goToMyOrders, displayWhiteHeader, showPwaHeaderBackButton, onLoginSuccess);
  };
}), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(99234)]
  }
});
const MMTHeaderWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99234)).then(mod => {
  const {
    withMMTInsuranceHeader
  } = mod;
  return function MMTHeaderWrapperComponent({
    children,
    headerOptions,
    mobileTitle,
    myOrders,
    goToMyOrders,
    displayWhiteHeader,
    isMyBiz,
    exitWebViewOnBack,
    showPwaHeaderBackButton,
    showPwaHeader
  }) {
    return withMMTInsuranceHeader( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
      children: children
    }), headerOptions, mobileTitle, myOrders, goToMyOrders, displayWhiteHeader, isMyBiz, exitWebViewOnBack, showPwaHeaderBackButton, showPwaHeader);
  };
}), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(99234)]
  }
});
var __N_SSP = true;
function CommonLandingPage({
  data,
  device = "mobile",
  error,
  // hasPartnerAuth,
  partner,
  referrer,
  cmp = "",
  experiment = "",
  query,
  commonsHeaderData,
  country,
  isTrackCookies,
  bgImageIndex,
  isMobileDevice
}) {
  const headTags = data?.headTags || {};
  const longImageUrl = data?.offers?.items?.[0]?.image_url;
  const {
    0: randomImage,
    1: setRandomImage
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRandomBgImage */ .K_)(bgImageIndex));
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
  const countryParam = router?.query?.country || country;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const cleanup = (0,_tm_utility_analytics__WEBPACK_IMPORTED_MODULE_11__/* .initGlobalErrorLogging */ .mY)(`seo_country_landing_${countryParam || "unknown"}`);
    return cleanup;
  }, [countryParam]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (0,_src_utils_webVitals__WEBPACK_IMPORTED_MODULE_13__/* .conditionallyLoadWebVitals */ .G)();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.MMT) {
      document.cookie = `isCommonLanding=true; domain=.makemytrip.com; path=/`;
    }

    const referrer = document.referrer;
    let hostname = referrer ? new URL(referrer).hostname : "";
    const url = new URL(window.location.href);

    if (!hostname) {
      hostname = url.hostname;
    }

    let updatedCmp = cmp;

    if (updatedCmp === "" && (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com")) {
      updatedCmp = "secondary_icon";
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .replaceHistory */ .df)("cmp", updatedCmp);
    }

    if (updatedCmp === "" && hostname === "www.google.com") {
      updatedCmp = "seo";
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .replaceHistory */ .df)("cmp", updatedCmp);
    }

    sessionStorage.setItem("cmp", updatedCmp); // const bgImage = getRandomBgImage();
    // const commonLandingMainWrapper = document.getElementById(
    //   "common-landing-main-wrapper"
    // );
    // if (commonLandingMainWrapper && bgImage) {
    //   commonLandingMainWrapper.style.backgroundImage = `url(${bgImage})`;
    // }
    // Set random image on client side only

    const bgImage = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRandomBgImage */ .K_)(bgImageIndex);
    setRandomImage(bgImage);
  }, [bgImageIndex, cmp, partner]);
  const {
    0: activeModal,
    1: setActiveModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");

  const goToMyOrders = () => {
    analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //'click'
    );
    const authCookie = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getCookieByName */ .A7)("mmt-auth") || (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getCookieByName */ .A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__/* .navigationActions.navigateToOrderListing */ .ej.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  const onModalChange = modal => {
    if (modal === "LOGIN" || modal === "") {
      setActiveModal(modal);
    }
  }; //TODO: Create a global context and move common data things there


  const comp = partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.MYPARTNER || partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.MYBIZ ? null : partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.GI ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_7__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.GI,
    "data-test-id": "comp-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(GIHeaderWrapper, {
      headerOptions: {
        Wrapper: props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_tm_static_pages__WEBPACK_IMPORTED_MODULE_6__.InsuranceGiCommonLandingPageMainWrapper, _objectSpread(_objectSpread({
          id: "common-landing-main-wrapper"
        }, props), {}, {
          "data-test-id": "comp-InsuranceGiCommonLandingPageMainWrapper"
        })),
        forceLogin: false
      },
      mobileTitle: "Secure International Travel",
      myOrders: true,
      goToMyOrders: goToMyOrders,
      "data-test-id": "comp-GIHeaderWrapper",
      children: isMobileDevice ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(InsuranceLanding, {
        setActiveModal: setActiveModal,
        data: data,
        query: query,
        "data-test-id": "comp-InsuranceLanding"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(InsuranceCommonLanding, {
        setActiveModal: setActiveModal,
        data: data,
        query: query,
        partnerType: partner,
        "data-test-id": "comp-InsuranceCommonLanding"
      })
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_7__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.MMT,
    "data-test-id": "comp-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(MMTHeaderWrapper, {
      headerOptions: {
        type: "dualHeader",
        Wrapper: props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(_tm_static_pages__WEBPACK_IMPORTED_MODULE_6__.InsuranceCommonLandingPageMainWrapper, _objectSpread(_objectSpread({
          style: {
            backgroundImage: `url(${randomImage}), linear-gradient(to bottom, #051322, #15457c)`,
            backgroundSize: "100% 643px"
          },
          id: "common-landing-main-wrapper"
        }, props), {}, {
          "data-test-id": "comp-InsuranceCommonLandingPageMainWrapper",
          children: [typeof randomImage === "string" && !isMobileDevice &&
          /*#__PURE__*/
          // eslint-disable-next-line @next/next/no-img-element
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("img", {
            src: randomImage,
            alt: "",
            style: {
              position: "absolute",
              width: 0,
              height: 0,
              opacity: 0,
              pointerEvents: "none"
            },
            fetchpriority: "high",
            loading: "eager"
          }), props.children]
        })),
        activeModal: activeModal || "",
        onModalChange: onModalChange,
        forceLogin: false,
        pokusExperiments: {
          insuranceNewFunnel: true
        },
        globalConfig: commonsHeaderData?.headerConfig?.value,
        headerCommonData: {
          loyaltyHeaderData: commonsHeaderData?.loyaltyHeaderData?.value,
          walletHeaderData: commonsHeaderData?.walletHeaderData?.value,
          mobileCore: commonsHeaderData?.mobileCore?.value,
          userInfoData: commonsHeaderData?.userInfoData?.value
        }
      },
      mobileTitle: "Insurance & Protection Plans",
      myOrders: true,
      goToMyOrders: goToMyOrders,
      displayWhiteHeader: false,
      isMyBiz: false,
      exitWebViewOnBack: false,
      showPwaHeaderBackButton: true,
      showPwaHeader: isMobileDevice,
      "data-test-id": "comp-MMTHeaderWrapper",
      children: isMobileDevice ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(InsuranceLanding, {
        setActiveModal: setActiveModal,
        data: data,
        query: query,
        "data-test-id": "comp-InsuranceLanding"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(InsuranceCommonLanding, {
        setActiveModal: setActiveModal,
        data: data,
        query: query,
        "data-test-id": "comp-InsuranceCommonLanding"
      })
    })
  });
  return (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_10__.withError)((0,_tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withReferrerProvider */ .ut)((0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_8__/* .withDeviceAndThemeProvider */ .OM)((0,_src_hoc__WEBPACK_IMPORTED_MODULE_15__/* .withSeoHeadTags */ ._)((0,_tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withExperimentTrackingStringProvider */ .IV)(comp, experiment), headTags, partner, longImageUrl), device, {
    pageTheme: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getThemePartner */ .JD)(partner)
  }), referrer), error, "COMMON_LANDING");
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonLandingPage);

/***/ }),

/***/ 10495:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance/[country]",
      function () {
        return __webpack_require__(20666);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [4775,98,6966,3633,437,9579,8584,3511,4891,6723,4044,7991,1935,8469,7512,3831,2148,8991,3365,6707,3437,4015,8187,6793,4657,5726,8073,6206,8656,110,9774,8597,8611,9681,1597,500,1285,2346,1516,7556,454,5802,3007,1359,3025,5401,9447,6874,8926,5642,3484,7740,1086,5405,1186,598,9758,179], () => (__webpack_exec__(10495)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);